/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Reason_OtherInputs */

const fr_vehicle_action_archive_reason_other = /** @type {(inputs: Vehicle_Action_Archive_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const en_vehicle_action_archive_reason_other = /** @type {(inputs: Vehicle_Action_Archive_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Vehicle_Action_Archive_Reason_OtherInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_reason_other = /** @type {((inputs?: Vehicle_Action_Archive_Reason_OtherInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Reason_OtherInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_reason_other(inputs)
	return en_vehicle_action_archive_reason_other(inputs)
});